import { render, staticRenderFns } from "./tagManagement.vue?vue&type=template&id=6505f583&scoped=true"
import script from "./tagManagement.vue?vue&type=script&lang=js"
export * from "./tagManagement.vue?vue&type=script&lang=js"
import style0 from "./tagManagement.vue?vue&type=style&index=0&id=6505f583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505f583",
  null
  
)

export default component.exports